import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { useIsFocused } from '@garnish/core';
import { ScreenHeader } from '@garnish/navigation';

import { useTelemetry } from '@order/Telemetry';

import { OrderStatusBar } from '../../../../components';
import { useIsLoggedIn } from '../../../../context/AuthMachine';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountScreenHeader = () => {
  const router = useRouter();
  const isFocused = useIsFocused();

  const { formatMessage } = useIntl();
  const { track } = useTelemetry();

  const isLoggedIn = useIsLoggedIn();

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldRenderCustomStatusBar = Platform.OS === 'android' && isFocused;

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handleScanPress = useCallback(() => {
    track('account_scan_selected');
    router.navigate('/scan-at-checkout');
  }, [router, track]);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <>
      {shouldRenderCustomStatusBar ? <OrderStatusBar barStyle="light-content" /> : null}

      <ScreenHeader.Container palette="kale">
        <ScreenHeader.Content>
          <ScreenHeader.Title>
            <FormattedMessage {...messages.accountTitle} />
          </ScreenHeader.Title>

          {isLoggedIn ? (
            <ScreenHeader.ScanButton
              title={formatMessage(messages.scanButton)}
              onPress={handleScanPress}
            />
          ) : null}
        </ScreenHeader.Content>
      </ScreenHeader.Container>
    </>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountTitle: {
    defaultMessage: 'Account',
    description: 'Account | Header | Title',
  },
  scanButton: {
    defaultMessage: 'Scan',
    description: 'Account | Header | Scan button',
  },
});
